export const helicone = {
    name: 'Helicone',
    products: {
        llm_analytics: {
            available: true,
            features: {
                generation_tracking: true,
                latency_tracking: true,
                cost_tracking: true,
                trace_visualization: true,
                token_tracking: true,
                prompt_playground: true,
                prompt_evaluations: true,
                alerting: true,
            },
        },
    },
}
